export default __webpack_public_path__ + "static/media/quizz1.9ca2b816.jpg";